import {putAll, showBeError, showSuccess, takeLatestF} from '@fl/cmsch-fe-library';
import {SagaIterator} from 'redux-saga';
import {opt} from 'ts-opt';
import {call, put} from 'typed-redux-saga';

import {Api} from 'api/gen/Api';
import {t} from 'app/translations';

import {adminAction, RemoveOrganizationRolesForUserAction} from '../action';

const tt = t('admin');

function* execute({payload: {userProfileId, organizationId}}: RemoveOrganizationRolesForUserAction): SagaIterator {
    const response = yield* call(
        Api.endUserProfileOrganizationRoleBindingForUserProfile,
        {userProfileId, organizationId},
    );

    if (response.isSuccess) {
        yield* put(adminAction.getManagementOrganizationsTableData(opt({action: 'refresh'}), organizationId));
        yield putAll(showSuccess(
            tt('removeRolesForUser'),
            tt('removeRolesForUserSuccess'),
            false,
            'removeRolesForUser',
        ));
    } else {
        yield putAll(showBeError(response, tt('removeRolesForUser')));
    }
}

/** Runs the admin saga that removes organization roles from the selected user. */
export function* removeOrganizationRolesForUserSaga(): SagaIterator {
    yield takeLatestF('admin/REMOVE_ORGANIZATION_ROLES_FOR_USER', execute);
}
